import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';
import { Button } from '../UI/button';

export default function LandingHero() {
  const { t } = useLocale();

  return (
    <section className="relative overflow-hidden border-b border-border-light">
      <div className="mesh-gradient-hero-panel">
        <div className="mesh-gradient-hero" aria-hidden />
        <div className={`${themeClasses.landing.containerWide} relative z-10 py-20 sm:py-28 lg:py-32`}>
          <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
            <p className={themeClasses.landing.eyebrow}>{t('landingHeroEyebrow')}</p>
            <h1 className={`${themeClasses.landing.heroTitle} mt-4`}>{t('landingHeroTitle')}</h1>
            <p className={`${themeClasses.landing.heroSubtitle} mx-auto mt-6`}>
              {t('landingHeroSubtitle')}
            </p>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
              <Button variant="default" size="pill" asChild>
                <Link to="/login">{t('landingCtaPrimary')}</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
